import { parseWebinarStartParts } from "./webinarStartDisplay";

function CalendarIcon({ className }) {
	return (
		<svg
			className={className}
			width="14"
			height="14"
			viewBox="0 0 20 23"
			fill="currentColor"
			aria-hidden
		>
			<path d="M6.25 5.25C5.84 5.25 5.5 4.91 5.5 4.5V1.5C5.5 1.09 5.84 0.75 6.25 0.75C6.66 0.75 7 1.09 7 1.5V4.5C7 4.91 6.66 5.25 6.25 5.25ZM14.25 5.25C13.84 5.25 13.5 4.91 13.5 4.5V1.5C13.5 1.09 13.84 0.75 14.25 0.75C14.66 0.75 15 1.09 15 1.5V4.5C15 4.91 14.66 5.25 14.25 5.25ZM18.75 9.34H1.75C1.34 9.34 1 9 1 8.59C1 8.18 1.34 7.84 1.75 7.84H18.75C19.16 7.84 19.5 8.18 19.5 8.59C19.5 9 19.16 9.34 18.75 9.34ZM14.25 22.25H6.25C2.6 22.25 0.5 20.15 0.5 16.5V8C0.5 4.35 2.6 2.25 6.25 2.25H14.25C17.9 2.25 20 4.35 20 8V16.5C20 20.15 17.9 22.25 14.25 22.25ZM6.25 3.75C3.39 3.75 2 5.14 2 8V16.5C2 19.36 3.39 20.75 6.25 20.75H14.25C17.11 20.75 18.5 19.36 18.5 16.5V8C18.5 5.14 17.11 3.75 14.25 3.75H6.25Z" />
		</svg>
	);
}

export default function WebinarCardStartMeta({ webinar, variant = "light", className = "" }) {
	const parts = parseWebinarStartParts(webinar);
	if (!parts) {
		return null;
	}

	const onDark = variant === "onDark";
	const muted = onDark ? "text-white/70" : "text-darkBlue/55";
	const strong = onDark ? "text-white" : "text-darkBlue";

	return (
		<div
			dir="rtl"
			className={[
				"flex w-full max-w-full items-center justify-start gap-1.5 rounded-[10px] border px-2.5 py-1.5 text-right",
				onDark
					? "border-white/20 bg-black/35 text-white backdrop-blur-sm"
					: "border-darkBlue/12 bg-gradient-to-l from-[#EEF4FB] to-white text-darkBlue",
				className,
			].join(" ")}
		>
			<span
				className={[
					"flex shrink-0 items-center justify-center rounded-md p-0.5",
					onDark ? "bg-white/15 text-white/90" : "bg-white text-darkBlue/70 shadow-sm",
				].join(" ")}
			>
				<CalendarIcon />
			</span>
			<span className={`shrink-0 font-Vazir-600 text-[12px] ${muted}`}>تاریخ شروع</span>
			{parts.date ? (
				<>
					<span className={`shrink-0 text-[11px] opacity-35 ${muted}`}>·</span>
					<span
						dir="ltr"
						className={`shrink-0 font-Vazir-700 text-[12px] tabular-nums ${strong}`}
					>
						{parts.date}
					</span>
				</>
			) : null}
			{parts.time ? (
				<>
					<span className={`shrink-0 text-[11px] opacity-35 ${muted}`}>·</span>
					<span
						dir="ltr"
						className={`min-w-0 truncate font-Vazir-500 text-[12px] tabular-nums ${muted}`}
					>
						{parts.time}
					</span>
				</>
			) : null}
		</div>
	);
}
